import { HorizontalBarChartComponent } from '../charts/horizontal-bar-chart-component'
import { MwChartOneSeriesBarOptions } from '@meltwater/mw-visualizations-angularjs'
import { IDataPoint } from '../../types'

export class AFWordCloudHorizontalBarChart { //} extends HorizontalBarChartComponent {
  static config = {
    selector: 'afWordCloudHorizontalBarChart',
    controller: AFWordCloudHorizontalBarChart,
    bindings: {
      visualizationId: '<',
      triggerUpdate:'<',
      vizData: '<',
      visTitle: '<',
      size: '<',
      isLoading: '<',
      isError: '<',
    },
    template: HorizontalBarChartComponent.config.template,
  }

  public colorPalette = ['#F84D80']

  $onInit() {
  }

  // $onChanges(changes) {
  //   if (changes.vizData && typeof changes.vizData.currentValue !== 'undefined') {
  //     if(!this.isObjEmpty(changes.vizData.currentValue.data)) {
  //       this.updateData(changes.vizData.currentValue.data);
  //       this.updateOptions();
  //     } else {
  //       this.visualizationData = {}
  //     }
  //   }
  // }

  // updateData(data) {
  //   this.visualizationData = this.buildWordCloudChartData(data.all, this.colorPalette);
  // }

  // updateOptions() {
  //   this.visualizationOptions = new MwChartOneSeriesBarOptions(this.buildWordCloudOptions(this.visualizationData.data, this.colorPalette))
  // }

  // buildWordCloudChartData(data: IDataPoint[], colorPalette: string[]) {
  //  return {
  //   name: 'Word Cloud',
  //   data: data.slice(0, 5).map((x, index) => ({ ...x, color: colorPalette[0] })),
  //  }
  // }

  // buildWordCloudOptions(data: IDataPoint[], colorPalette: string[]) {
  //  return {
  //   seriesColor: colorPalette[0],
  //   onPointClick: ({key}) => {
  //    this.triggerUpdate(this.updatePayload('FILTER_CHANGE', 'append', 'subKeyword', key))
  //   },
  //   tooltipFormatter: ({ key, value }: IDataPoint) => `<strong>${key}</strong>: ${value}`,
  //  }
  // }
}
